import topic from "@api/topic";
export const imgeAPI = {
    uploadImage: topic.imgeTopic + '/upload_image'
}